import { useContext } from 'react';
import { ReactRouterContext } from '../components';

function useSearchParams(): [URLSearchParams] {
    const { location } = useContext(ReactRouterContext);

    return [new URLSearchParams(location.search)];
}

export default useSearchParams;
